
















import { Component, Prop, Vue } from "vue-property-decorator";
import { ProductInstanceResult } from "@futuri/cloudsso-client/src/client/types/productInstances";
import { TOPLINE } from "@futuri/cloudsso-client/src/client/types/productType";

export type OnSelect = (
  instance: ProductInstanceResult,
  event?: MouseEvent
) => Promise<void>;

const defaultLogo =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

@Component
export default class InstanceCard extends Vue {
  @Prop() private instance!: ProductInstanceResult;
  @Prop() private select?: OnSelect;

  get title() {
    return this.instance?.name?.toUpperCase();
  }
  get logo() {
    return this.instance?.icon ?? defaultLogo;
  }
  get product() {
    return this.instance?.product;
  }

  async cardClick(event: MouseEvent) {
    const { product, redirectUrl } = this.instance;
    if (product === TOPLINE) {
      window.open(redirectUrl);
    }

    const { srcElement } = event;
    console.log("srcElement: ", srcElement);

    if (this.select) {
      this.select(this.$props.instance, event);
      return;
    }
  }
}
